'use strict';

function isAnimationControls(v) {
    return (v !== null &&
        typeof v === "object" &&
        typeof v.start === "function");
}

exports.isAnimationControls = isAnimationControls;
//# sourceMappingURL=is-animation-controls.cjs.map
